var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayStore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 140,
    height: 40,
    viewBox: "0 0 140 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Google Play"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "BG",
    d: "M134.815 40H5.18519C2.33463 40 0 37.7488 0 35V5C0 2.25125 2.33463 2.38419e-06 5.18519 2.38419e-06H134.815C137.665 2.38419e-06 140 2.25125 140 5V35C140 37.7488 137.665 40 134.815 40Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Border",
    d: "M134.815 0.801251C137.216 0.801251 139.169 2.685 139.169 5V35C139.169 37.315 137.216 39.1988 134.815 39.1988H5.18519C2.78444 39.1988 0.830926 37.315 0.830926 35V5C0.830926 2.685 2.78444 0.801251 5.18519 0.801251H134.815ZM134.815 2.38419e-06H5.18519C2.33463 2.38419e-06 0 2.25125 0 5V35C0 37.7488 2.33463 40 5.18519 40H134.815C137.665 40 140 37.7488 140 35V5C140 2.25125 137.665 2.38419e-06 134.815 2.38419e-06Z",
    fill: "#A6A6A6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10.8208 7.53869C10.5161 7.84619 10.3398 8.32494 10.3398 8.94494V31.0599C10.3398 31.6799 10.5161 32.1587 10.8208 32.4662L10.896 32.5337L23.7474 20.1462V19.8537L10.896 7.46619L10.8208 7.53869Z",
    fill: "url(#paint0_linear_733_63677)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M28.0252 24.2773L23.7461 20.1461V19.8536L28.0304 15.7223L28.1263 15.7761L33.2 18.5598C34.6479 19.3498 34.6479 20.6498 33.2 21.4448L28.1263 24.2236L28.0252 24.2773Z",
    fill: "url(#paint1_linear_733_63677)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M28.1272 24.2237L23.747 20L10.8203 32.4662C11.3012 32.9537 12.0855 33.0125 12.9773 32.525L28.1272 24.2237Z",
    fill: "url(#paint2_linear_733_63677)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M28.1272 15.7763L12.9773 7.475C12.0855 6.9925 11.3012 7.05125 10.8203 7.53875L23.747 20L28.1272 15.7763Z",
    fill: "url(#paint3_linear_733_63677)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "GET IT ON"
  }, /*#__PURE__*/React.createElement("path", {
    id: "G",
    d: "M49.1724 10.2437C49.1724 11.0787 48.9132 11.7475 48.4024 12.2462C47.8152 12.8375 47.0504 13.135 46.1132 13.135C45.2174 13.135 44.4526 12.8325 43.8252 12.2362C43.1965 11.6312 42.8828 10.8887 42.8828 9.99999C42.8828 9.11124 43.1965 8.36874 43.8252 7.76874C44.4526 7.16749 45.2174 6.86499 46.1132 6.86499C46.5591 6.86499 46.9843 6.95374 47.39 7.11874C47.7945 7.28499 48.1237 7.50999 48.3623 7.78749L47.8204 8.31499C47.4043 7.84124 46.8378 7.60749 46.1132 7.60749C45.4599 7.60749 44.8934 7.82749 44.4124 8.27124C43.9367 8.71624 43.6982 9.29249 43.6982 9.99999C43.6982 10.7075 43.9367 11.2887 44.4124 11.7337C44.8934 12.1725 45.4599 12.3975 46.1132 12.3975C46.8067 12.3975 47.39 12.1725 47.8502 11.7287C48.1536 11.435 48.326 11.03 48.3713 10.5125H46.1132V9.78999H49.1258C49.1621 9.94624 49.1724 10.0975 49.1724 10.2437Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "E",
    d: "M53.9512 7.73869H51.1214V9.63869H53.6725V10.3612H51.1214V12.2612H53.9512V12.9974H50.3203V7.00244H53.9512V7.73869Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "T",
    d: "M57.3259 12.9974H56.5248V7.73869H54.7891V7.00244H59.063V7.73869H57.3259V12.9974Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "I",
    d: "M62.1562 12.9974V7.00244H62.9561V12.9974H62.1562Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "T_2",
    d: "M66.5017 12.9974H65.7071V7.73869H63.9648V7.00244H68.2439V7.73869H66.5017V12.9974Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "O",
    d: "M76.3349 12.2262C75.7218 12.8325 74.9621 13.135 74.056 13.135C73.1447 13.135 72.3851 12.8325 71.772 12.2262C71.1601 11.6212 70.8555 10.8787 70.8555 9.99999C70.8555 9.12124 71.1601 8.37874 71.772 7.77374C72.3851 7.16749 73.1447 6.86499 74.056 6.86499C74.9569 6.86499 75.7166 7.16749 76.3297 7.77874C76.9468 8.38874 77.2514 9.12624 77.2514 9.99999C77.2514 10.8787 76.9468 11.6212 76.3349 12.2262ZM72.3644 11.7237C72.8258 12.1725 73.3871 12.3975 74.056 12.3975C74.7197 12.3975 75.2862 12.1725 75.7425 11.7237C76.2027 11.275 76.436 10.6987 76.436 9.99999C76.436 9.30124 76.2027 8.72499 75.7425 8.27624C75.2862 7.82749 74.7197 7.60249 74.056 7.60249C73.3871 7.60249 72.8258 7.82749 72.3644 8.27624C71.9042 8.72499 71.6708 9.30124 71.6708 9.99999C71.6708 10.6987 71.9042 11.275 72.3644 11.7237Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "N",
    d: "M78.375 12.9974V7.00244H79.3472L82.3702 11.6649H82.4052L82.3702 10.5124V7.00244H83.17V12.9974H82.3352L79.1696 8.10494H79.1346L79.1696 9.26244V12.9974H78.375Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.16,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "Google Play_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Google Play_3",
    d: "M70.6571 21.7524C68.2214 21.7524 66.2315 23.5399 66.2315 26.0061C66.2315 28.4524 68.2214 30.2586 70.6571 30.2586C73.098 30.2586 75.0878 28.4524 75.0878 26.0061C75.0878 23.5399 73.098 21.7524 70.6571 21.7524ZM70.6571 28.5836C69.3206 28.5836 68.1708 27.5199 68.1708 26.0061C68.1708 24.4724 69.3206 23.4274 70.6571 23.4274C71.9936 23.4274 73.1486 24.4724 73.1486 26.0061C73.1486 27.5199 71.9936 28.5836 70.6571 28.5836ZM61.001 21.7524C58.5601 21.7524 56.5754 23.5399 56.5754 26.0061C56.5754 28.4524 58.5601 30.2586 61.001 30.2586C63.4406 30.2586 65.4265 28.4524 65.4265 26.0061C65.4265 23.5399 63.4406 21.7524 61.001 21.7524ZM61.001 28.5836C59.6632 28.5836 58.5095 27.5199 58.5095 26.0061C58.5095 24.4724 59.6632 23.4274 61.001 23.4274C62.3375 23.4274 63.4873 24.4724 63.4873 26.0061C63.4873 27.5199 62.3375 28.5836 61.001 28.5836ZM49.5106 23.0561V24.8636H53.9867C53.8558 25.8736 53.5058 26.6161 52.9691 27.1336C52.3158 27.7586 51.2982 28.4524 49.5106 28.4524C46.756 28.4524 44.599 26.3086 44.599 23.6524C44.599 20.9961 46.756 18.8524 49.5106 18.8524C51.0001 18.8524 52.0838 19.4136 52.8836 20.1411L54.2045 18.8674C53.0858 17.8374 51.5977 17.0461 49.5106 17.0461C45.7332 17.0461 42.5586 20.0099 42.5586 23.6524C42.5586 27.2949 45.7332 30.2586 49.5106 30.2586C51.5523 30.2586 53.0858 29.6136 54.2914 28.4036C55.5267 27.2124 55.9117 25.5374 55.9117 24.1849C55.9117 23.7649 55.8754 23.3786 55.8106 23.0561H49.5106ZM96.4962 24.4574C96.1319 23.5061 95.008 21.7524 92.7188 21.7524C90.4502 21.7524 88.5615 23.4761 88.5615 26.0061C88.5615 28.3886 90.4308 30.2586 92.9365 30.2586C94.9626 30.2586 96.1319 29.0674 96.6128 28.3736L95.1091 27.4074C94.6075 28.1149 93.9243 28.5836 92.9365 28.5836C91.9552 28.5836 91.2513 28.1499 90.8002 27.2949L96.6997 24.9411L96.4962 24.4574ZM90.4814 25.8736C90.4308 24.2336 91.8023 23.3936 92.7849 23.3936C93.5549 23.3936 94.2082 23.7649 94.426 24.2961L90.4814 25.8736ZM85.6863 29.9999H87.6256V17.4999H85.6863V29.9999ZM82.5104 22.6999H82.4456C82.0101 22.2024 81.1791 21.7524 80.1265 21.7524C77.9177 21.7524 75.898 23.6224 75.898 26.0199C75.898 28.4036 77.9177 30.2586 80.1265 30.2586C81.1791 30.2586 82.0101 29.8049 82.4456 29.2924H82.5104V29.9024C82.5104 31.5286 81.6095 32.4024 80.1564 32.4024C78.9715 32.4024 78.2365 31.5774 77.9332 30.8836L76.2467 31.5624C76.7328 32.6899 78.0201 34.0774 80.1564 34.0774C82.4301 34.0774 84.3486 32.7874 84.3486 29.6486V22.0111H82.5104V22.6999ZM80.2925 28.5836C78.956 28.5836 77.8373 27.5049 77.8373 26.0199C77.8373 24.5211 78.956 23.4274 80.2925 23.4274C81.6095 23.4274 82.6478 24.5211 82.6478 26.0199C82.6478 27.5049 81.6095 28.5836 80.2925 28.5836ZM105.575 17.4999H100.937V29.9999H102.871V25.2636H105.575C107.723 25.2636 109.83 23.7649 109.83 21.3811C109.83 18.9986 107.718 17.4999 105.575 17.4999ZM105.626 23.5249H102.871V19.2386H105.626C107.07 19.2386 107.894 20.3949 107.894 21.3811C107.894 22.3486 107.07 23.5249 105.626 23.5249ZM117.582 21.7286C116.184 21.7286 114.731 22.3236 114.134 23.6424L115.85 24.3361C116.219 23.6424 116.899 23.4174 117.617 23.4174C118.62 23.4174 119.638 23.9986 119.653 25.0249V25.1561C119.303 24.9611 118.554 24.6724 117.632 24.6724C115.784 24.6724 113.9 25.6536 113.9 27.4849C113.9 29.1599 115.414 30.2386 117.116 30.2386C118.418 30.2386 119.136 29.6724 119.587 29.0136H119.653V29.9799H121.521V25.1849C121.521 22.9686 119.805 21.7286 117.582 21.7286ZM117.348 28.5786C116.716 28.5786 115.834 28.2761 115.834 27.5199C115.834 26.5524 116.934 26.1811 117.885 26.1811C118.737 26.1811 119.136 26.3624 119.653 26.6011C119.502 27.7586 118.468 28.5786 117.348 28.5786ZM128.327 22.0024L126.104 27.4211H126.037L123.739 22.0024H121.653L125.107 29.5749L123.136 33.7886H125.157L130.479 22.0024H128.327ZM110.893 29.9999H112.832V17.4999H110.893V29.9999Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_733_63677",
    x1: 22.6064,
    y1: 31.2902,
    x2: 5.83507,
    y2: 13.8978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_733_63677",
    x1: 35.0855,
    y1: 19.9984,
    x2: 9.9924,
    y2: 19.9984,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_733_63677",
    x1: 25.7453,
    y1: 17.7039,
    x2: 3.00209,
    y2: -5.88172,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_733_63677",
    x1: 7.5664,
    y1: 39.8238,
    x2: 17.7223,
    y2: 29.2919,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayStore);
export default __webpack_public_path__ + "static/media/playStore.7ad213fedf1612cdf6860bca8cf81b08.svg";
export { ForwardRef as ReactComponent };